import * as React from 'react';
import * as ReactionIcons from '@wix/wix-ui-icons-common/on-stage/reactions';
import { ReactionDefinition, ReactionType } from '.';
import { classes } from './reactions.visual.st.css';

export const heartItemsData: Partial<
  Record<ReactionType, Pick<ReactionDefinition, 'icon' | 'label'>>
> = {
  heart: { label: 'Heart', icon: <ReactionIcons.Heart /> },
  lol: { label: 'LOL', icon: <ReactionIcons.SmileyTears /> },
  angry: { label: 'Angry', icon: <ReactionIcons.Angry /> },
  surprised: { label: 'Surprised', icon: <ReactionIcons.Surprised /> },
  thinking: { label: 'Thinking', icon: <ReactionIcons.Suspicious /> },
};
export const heartItems = Object.keys(heartItemsData).filter(
  (item) => item !== 'heart',
) as ReactionType[];

export const thumbsUpItemsData: Partial<
  Record<ReactionType, Pick<ReactionDefinition, 'icon' | 'label'>>
> = {
  thumbsup: { label: 'Like', icon: <ReactionIcons.ThumbUp /> },
  thumbsdown: {
    label: 'ThumbsDown',
    icon: <ReactionIcons.ThumbUp className={classes.thumbsdown} />,
  },
  smiley: { label: 'Happy', icon: <ReactionIcons.Smiley /> },
  clap: { label: 'Clap', icon: <ReactionIcons.Clapping /> },
  sad: { label: 'Sad', icon: <ReactionIcons.Sad /> },
};
export const thumbsupItems = Object.keys(thumbsUpItemsData).filter(
  (item) => item !== 'thumbsup',
) as ReactionType[];
